// plugins/vuetify.ts

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {  
      mdi,
    },
  },
  defaults: {
    VApp: {
      fontFamily: 'Noto Sans KR',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2E7D32', // 짙은 초록
          secondary: '#E65100', // 짙은 오렌지
          accent: '#4CAF50', // 밝은 초록
          error: '#F44336',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FF9800', // 오렌지
          background: '#FFFFFF',
          surface: '#F5F5F5',
        },
      },
    },
  },
})
